angular.module('app.coverage.channels.channelsService', [])
  .factory('app.coverage.channels.channelsService', [
    '$http',
    function ($http) {
      let channels;
      channels = {
        list: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('platforms'))
            .then((response) => {
              let data = response.data;

              if (data.error) {
                channels.error = data.error;
              }
              else {
                channels.error = null;
                channels.list = data;
              }
            });
        }
      };
      return channels;
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/coverage/channels/channelsService.js